import { render, staticRenderFns } from "./inspectionSecond.vue?vue&type=template&id=2c5dec01&scoped=true&"
import script from "./inspectionSecond.vue?vue&type=script&lang=js&"
export * from "./inspectionSecond.vue?vue&type=script&lang=js&"
import style0 from "./inspectionSecond.vue?vue&type=style&index=0&id=2c5dec01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5dec01",
  null
  
)

export default component.exports